/**
 * ONE TURN, ONE RUN — the per-turn nonce (filed from the no-resend review).
 *
 * Every FroggerAI turn — a typed sentence, a spoken one, an Undo press, a
 * queued `initialUtterance` — carries a fresh `turn_id` minted ONCE for
 * that turn. The server claims it before running anything
 * (`frogger_ai/langgraph/turn_claim.py`), so a browser or proxy that
 * silently retries the request (the stream is a GET with side effects) runs
 * nothing the second time.
 */
export const newTurnId = () => {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
      const b = crypto.getRandomValues(new Uint8Array(16));
      b[6] = (b[6] & 0x0f) | 0x40; // eslint-disable-line no-bitwise
      b[8] = (b[8] & 0x3f) | 0x80; // eslint-disable-line no-bitwise
      const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
      return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
    }
  } catch (e) { /* fall through */ }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    // eslint-disable-next-line no-bitwise
    return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
  });
};

export default newTurnId;
